import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { AuthService } from "src/app/_services/auth.service";

@Injectable({
    providedIn: "root",
})
export class NotAuthGuard {
    constructor(
        private readonly authService: AuthService,
        private readonly router: Router,
    ) {}

    canActivate(): Observable<boolean> {
        const isAuthenticated = this.authService.isAuthenticated;

        if (isAuthenticated) {
            this.router.navigate(["/app"]);

            return of(false);
        }

        return of(true);
    }
}
